export default class SlotMarker extends Phaser.Group {
  constructor(game, x, y) {
    super(game);

    this.x = x;
    this.y = y;

    this.marker = this.game.make.image(0, 8, 'ui_various', 'slot_marker');
    this.marker.anchor.set(0.5);

    this.circles = [];
    const amount = 1;
    const time = 1500;
    const delay = time / amount;
    for (let i = 0; i < amount; i++) {
      const circle = this.game.make.image(0, 0, 'ui_various', 'slot_circle');
      circle.anchor.set(0.5);
      const tweenS = this.game.add
        .tween(circle.scale)
        .to({ x: 1.7, y: 1.7 }, time, null, true, i * delay, -1);
      const tweenA = this.game.add.tween(circle).to({ alpha: 0 }, time, null, true, i * delay, -1);
      this.circles.push({ tweenS, tweenA, circle });
      this.addChild(circle);
    }

    this.addChild(this.marker);
  }

  destroy() {
    for (let i = 0; i < this.circles.length; i++) {
      this.circles[i].tweenA.stop();
      this.circles[i].tweenS.stop();
      this.circles[i].circle.destroy();
    }
    this.marker.destroy();

    this.circles = null;
    this.marker = null;

    super.destroy();
  }
}
